import { SwitchHorizontal01Icon } from '@langchain/untitled-ui-icons';

import AnthropicLogo from '@/icons/AnthropicLogo.svg?react';
import ChainIcon from '@/icons/ChainIcon.svg?react';
import ChatPromptIcon from '@/icons/ChatPromptIcon.svg?react';
import DeepSeekLogo from '@/icons/DeepSeekLogo.svg?react';
import LLMIcon from '@/icons/LLMIcon.svg?react';
import MessageChatIcon from '@/icons/MessageChatIcon.svg?react';
import OpenAILogo from '@/icons/OpenAILogo.svg?react';
import ParallelIcon from '@/icons/ParallelIcon.svg?react';
import ParserIcon from '@/icons/ParserIcon.svg?react';
import RetrieverIcon from '@/icons/RetrieverIcon.svg?react';
import SequenceIcon from '@/icons/SequenceIcon.svg?react';
import ToolIcon from '@/icons/ToolIcon.svg?react';

import { RunSchema } from '../types/schema';

export function RunTypeIcon({
  run,
  className,
  height,
  width,
  fill,
  stroke,
  x,
  y,
  color,
  rootRunFormat,
}: {
  run: Pick<RunSchema, 'name' | 'run_type'> | undefined | null;
  className?: string;
  rootRunFormat?: 'trace' | 'thread';
} & React.SVGProps<SVGSVGElement>) {
  if (run == null) return null;

  const htmlProps = {
    className,
    height: height ?? 24,
    width: width ?? 24,
    fill,
    stroke,
    x,
    y,
    color,
  };

  if (run.run_type === 'tool') {
    // TODO: determine if calcuator, search or generic tool
    return <ToolIcon {...htmlProps} />;
  }

  if (run.run_type === 'retriever') {
    return <RetrieverIcon {...htmlProps} />;
  }

  if (run.run_type === 'parser') {
    return <ParserIcon {...htmlProps} />;
  }

  if (run.run_type === 'prompt') {
    return <ChatPromptIcon {...htmlProps} fill="transparent" />;
  }

  if (run.run_type === 'llm') {
    if (run.name === 'OpenAI' || run.name === 'ChatOpenAI') {
      return <OpenAILogo {...htmlProps} />;
    }

    if (run.name === 'Anthropic' || run.name === 'ChatAnthropic') {
      return <AnthropicLogo {...htmlProps} />;
    }
    if (run.name === 'DeepSeek' || run.name === 'ChatDeepSeek') {
      return <DeepSeekLogo {...htmlProps} />;
    }

    return <LLMIcon {...htmlProps} />;
  }

  if (run.run_type === 'thread') {
    if (rootRunFormat === 'thread') {
      return <SwitchHorizontal01Icon {...htmlProps} />;
    }
    return <MessageChatIcon {...htmlProps} />;
  }

  if (run.run_type === 'chain') {
    if (run.name === 'RunnableSequence') {
      return <SequenceIcon {...htmlProps} />;
    }

    if (run.name === 'RunnableParallel') {
      return <ParallelIcon {...htmlProps} />;
    }

    return <ChainIcon {...htmlProps} />;
  }

  return <ChainIcon {...htmlProps} />;
}
